export enum DownTimePlannedCategoryenum{
    PLANNED='PLANNED',
    UN_PLANNED='UN PLANNED'
}
export const DownTimePlannedCategoryenumDropDown = [
    {name : 'PLANNED',value:'PLANNED'},{name : 'UN PLANNED',value:'UN PLANNED'}
]